import React, { memo, useCallback } from "react";

import type { Fund, Locale } from "../types";
import localization from "../localization";

import { Slider } from "@mui/material";
import { getCurrencyForInvestmentCompany, getCurrenySignForInvestmentCompany } from "../utils";

type SliderComponentProps = {
  locale: Locale;
  fund: Fund;
  value: number;
  label: string;
  step: number;
  min: number;
  max: number;
  // Match MUI Slider onChange signature (no activeThumb argument)
  handleChange: (event: Event, value: number | number[]) => void;
  handleChangeCommited: (
    event: Event | React.SyntheticEvent<Element, Event>,
    value: number | number[],
  ) => void;
};

const SliderComponent = memo((props: SliderComponentProps) => {
  const { locale, fund, value, label, step, min, max, handleChange, handleChangeCommited } = props;

  const { localeString } = localization[locale];

  const currency = getCurrencyForInvestmentCompany({
    investmentCompanyShort: fund?.investmentCompanyShort,
    locale: localization[locale],
  });

  const handleValueLabelFormat = useCallback(
    (value: number) =>
      new Intl.NumberFormat(localeString, {
        style: "currency",
        currency: currency }).format(value),
    // include dependencies used inside the callback
    [localeString, fund],
  );

  return (
    <Slider
      size="small"
      value={value}
      aria-label={label}
      valueLabelDisplay="auto"
      step={step}
      min={min}
      max={max}
      valueLabelFormat={handleValueLabelFormat}
      onChange={handleChange}
      onChangeCommitted={handleChangeCommited}
    />
  );
});

export default SliderComponent;
